import { render } from "./IntroText.vue?vue&type=template&id=bb12a280&scoped=true"
import script from "./IntroText.vue?vue&type=script&lang=js"
export * from "./IntroText.vue?vue&type=script&lang=js"

import "./IntroText.vue?vue&type=style&index=0&id=bb12a280&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb12a280"]])

export default __exports__